const soundEventSerializer = ((node) => {
  return `<soundEvent src="${node.src}"/>`;
});

export { soundEventSerializer };
//# sourceMappingURL=serializer.js.map
